const TimelineParent = (props) => {
    return <div id={props.id} className={'timeline-parent ' + props.className}>
        <section>
        {props.children}
        </section>
    </div>
}

export default TimelineParent;
